import script from "./cau-hinh-tram.vue?vue&type=script&setup=true&lang=js"
export * from "./cau-hinh-tram.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__